const tags = ['Milestones'];

export { tags };
